<template>
  <div class="form-row d-info d-frame">
    <h3>Sony PlayStation®Network UZUPEŁNIENIE FUNDUSZY W PORTFELU</h3>
    <p>Prosty sposób na zwiększenie swoich funduszy w portfelu PlayStation®Network bez konieczności korzystania z karty kredytowej.</p>

    <p><a href="" @click.prevent="showMore = true" v-if="!showMore">więcej informacji</a></p>
    <div v-if="showMore">
      <p>Doładuj swój portfel PSN, by kupować pełne wersje gier, dodatki i inne treści w PlayStation®Store, dostęp, do którego masz za pomocą PS4, PS3 lub PS Vita</p>
      <p>Wśród fantastycznych materiałów, które znajdziesz w PlayStation®Store, są:</p>
      <ul>
        <li>Gry i dodatki do nich</li>
        <li>Muzyka</li>
        <li>Awatary i motywy</li>
        <li>Najnowsze gry, dodatki i inne treści</li>
      </ul>

      <h3>JAK ZREALIZOWAĆ KOD:</h3>
      <ol>
        <li>Zaloguj się do PlayStation™Network albo utwórz konto na stronie <a href="https://playstation.com" target="_blank">playstation.com</a>.</li>
        <li>W PlayStation™Store przejdź do „Zrealizuj kody” i wpisz 12-cyfrowy kod kuponu.</li>
      </ol>

      <h3>UWAGA:</h3>
      <p>Wydawca kodu kuponu: firma Sony Interactive Entertainment Network Europe Ltd (zarejestrowana pod numerem 06020283), z siedzibą pod adresem 10 Great Marlborough St., Londyn, W1F 7LP, Wielka Brytania. Zastosowanie mają pełne warunki korzystania, które można znaleźć na stronie www.playstation.com/legal/PSNTerms.</p>

      <h3>ZASADY i WARUNKI KORZYSTANIA</h3>
      <p>Zamówienie można anulować w ciągu 14 dni od daty dostarczenia kodu i uzyskać zwrot w wysokości ceny zakupu. W sprawach związanych z anulowaniem i zwrotami prosimy kontaktować się z nami pod adresem e-mail
        <a href="mailto:reklamacje_karty@autopay.pl">reklamacje_karty@autopay.pl</a> lub numerem telefonu <a href="tel:48587604844">+48 58 760 48 44</a>. Można również przesłać do nas korespondencję pod adres
        <a href="mailto:karty@autopay.pl">karty@autopay.pl</a>.</p>
      <p>Wydawca kodu kuponu: firma Sony Interactive Entertainment Network Europe Ltd (zarejestrowana pod numerem 06020283), z siedzibą pod adresem 10 Great Marlborough St., Londyn, W1F 7LP, Wielka Brytania. Kod może zostać zrealizowany wyłącznie u wydawcy przez użytkowników, którzy ukończyli 18 lat i mają konto PlayStation™Network zarejestrowane w Polsce. Zastosowanie mają warunki świadczenia usługi, polityka prywatności, warunki korzystania z kodu kuponu, warunki użytkowania oprogramowania oraz dodatkowe warunki dotyczące treści/usług. Więcej informacji na stronie <a href="https://www.playstation.com/legal/PSNTerms" target="_blank">www.playstation.com/legal/PSNTerms</a>. Jeżeli nie akceptujesz tych warunków, nie dokonuj zakupu.</p>
      <p>Fundusze w portfelu PSN mogą zostać wykorzystane przez właścicieli kont do regulowania płatności za produkty zakupione w PlayStation™Store dostępnym dla właścicieli kont w Polsce. W&nbsp;stosunku do właścicieli kont, którzy nie ukończyli 18 lat, mają zastosowanie dodatkowe ograniczenia. Niektóre zakupy subskrypcji wymagają, by właściciel konta miał na nim zarejestrowaną kartę płatniczą.</p>
      <p>Wymagane jest posiadanie systemu PlayStation®3, PlayStation®Vita, PlayStation®4 lub innego kompatybilnego systemu firmy Sony, a także działającego łącza internetowego. Opłacenie szerokopasmowego połączenia z Internetem leży w gestii użytkownika.</p>
      <p>Kodu kuponu nie można wymienić na gotówkę, sprzedać ani wymienić na cokolwiek innego. Kod nie zostanie wymieniony w przypadku jego zagubienia, kradzieży lub wykorzystania bez Twojej zgody.  Kod można zrealizować tylko raz.</p>
      <p>Sprzedawca detaliczny działa jako pełnomocnik wydawcy.</p>
      <p><a href="" @click.prevent="showMore = false">zwiń</a></p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TopupCodesInfoPlaystationStore',
  data () {
    return {
      showMore: false
    }
  }
}
</script>
